import React, { FunctionComponent, useMemo } from "react";
import AssetsContext, { AssetsContextValue } from "contexts/AssetsContext";
import useFancyBearsInWallet from "hooks/useFancyBearsInWallet";
import useHoneyJarsInWallet from "hooks/useHoneyJarsInWallet";
import useConnectedAccount from "hooks/useConnectedAccount";
import { useBalance } from "wagmi";
import useHoneyBalance from "hooks/useHoneyBalance";
import useTraitsInWallet from "hooks/useTraitsInWallet";

const AssetsProvider: FunctionComponent = ({ children }) => {
  const [address] = useConnectedAccount();

  const [{ data: balanceData }] = useBalance({
    addressOrName: address,
  });

  const [honeyBalance, readHoneyBalance] = useHoneyBalance(address);

  const [fancyBearsInWallet, readFancyBearsInWallet] =
    useFancyBearsInWallet(address);

  const [honeyJarsInWallet, readHoneyJarsInWallet] =
    useHoneyJarsInWallet(address);

  const [traitsInWallet] = useTraitsInWallet(address);

  const contextValue = useMemo<AssetsContextValue>(
    () => ({
      balance: balanceData?.value,
      formattedBalance: balanceData?.formatted,
      honeyBalance,
      fancyBearsInWallet,
      fancyBearsInWalletCount: fancyBearsInWallet?.length,
      honeyJarsInWallet,
      honeyJarsInWalletCount: honeyJarsInWallet?.length,
      traitsInWallet,
      traitsInWalletCount: traitsInWallet?.length,
      readFancyBearsInWallet,
      readHoneyJarsInWallet,
      readHoneyBalance,
    }),
    [
      honeyBalance,
      balanceData,
      fancyBearsInWallet,
      honeyJarsInWallet,
      traitsInWallet,
      readFancyBearsInWallet,
      readHoneyJarsInWallet,
      readHoneyBalance,
    ]
  );

  return (
    <AssetsContext.Provider value={contextValue}>
      {children}
    </AssetsContext.Provider>
  );
};

export default AssetsProvider;
